import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { ServiceOrder } from '../../Serviceorder/serviceorder'; 
import { ServiceOrder } from '../../Serviceorder/models/service-order';
import { ServiceOrderService } from '../../Service/service-order-service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-serviceorder-add',
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './serviceorder-add.html',
  styleUrls: ['./serviceorder-add.css'],
})
export class ServiceorderAdd implements OnInit {
  ordenForm!: FormGroup;

  constructor(
    private serviceOrderService: ServiceOrderService,
    private fb: FormBuilder
  ){ }

ngOnInit(): void {
  this.ordenForm = this.fb.group({
    // Cabecero

    id: [null],
    addressNumber: ['', Validators.required],
    tecnicoAsignado: [''],
    businessUnit: [''],
    companyKey: [''],
    creditNotUuid: [''],
    creditNoteUploadDate: [''],
    currencyCode: [''],
    currencyMode: [''],
    dateRequested: [''],
    dateEnd: [''],
    deliveryInst1: [''],
    deliveryInst2: [''],
    description: [''],
    documentCompany: [''],
    email: ['', Validators.email], // opcional pero con formato válido
    estimatedPaymentDate: [''],
    exchangeRate: [0, Validators.required],
    foreignAmount: [0, Validators.required],
    invoiceAmount: [0, Validators.required],
    invoiceNumber: [''],
    invoiceUploadDate: [''],
    invoiceUuid: [''],
    longCompanyName: [''],
    notes: [''],
    orderAmount: [0, Validators.required],
    orderCompany: [''],
    orderNumber: [0, Validators.required],
    orderStatus: [''],
    orderSuffix: [''],
    orderType: [''],
    originalOrderAmount: [0, Validators.required],
    originalOrderNumber: [''],
    originalOrderType: [''],
    paymentType: [''],
    paymentUploadDate: [''],
    paymentUuid: [''],
    promiseDelivery: [''],
    rejectNotes: [''],
    relatedStatus: [''],
    relievedAmount: [0, Validators.required],
    remark: [''],
    sentToWns: [''],
    shipTo: [''],
    shortCompanyName: [''],
    status: [''],
    supplierEmail: [''],
    transferDate: [''],
    transferStatus: [''],

    // Detalle (Array dinámico)
    detalles: this.fb.array([this.crearLinea()])
  });     
}

// Getter para acceder al FormArray
get detalles(): FormArray {
  return this.ordenForm.get('detalles') as FormArray;
}


// Estructura de una nueva línea
crearLinea(): FormGroup {
  return this.fb.group({

    id: [null],
    accountId: [''],
    altItemNumber: [''],
    amount: [0, Validators.required],
    amountReceived: [0, Validators.required],
    codigoSat: [''],
    currency: [''],
    currencyCode: [''],
    exchangeRate: [0, Validators.required],
    extendedPrice: [0, Validators.required],
    foreignAmount: [0, Validators.required],
    glOffSet: [''],
    itemDescription: ['', Validators.required],
    itemNumber: [''],
    lineNumber: [0, Validators.required],
    lineStatus: [''],
    lineType: [''],
    location: [''],
    lotExpirationDate: [''],
    lotNumber: [''],
    notes: [''],
    objectAccount: [''],
    openAmount: [0, Validators.required],
    orderCompany: [''],
    orderNumber: [0, Validators.required],
    orderType: [''],
    pending: [0, Validators.required],
    quantity: [0, Validators.required],
    reason: [''],
    receiptType: [''],
    received: [0, Validators.required],
    receptionBy: [''],
    receptionDate: [''],
    rejected: [0, Validators.required],
    status: [''],
    taxCode: [''],
    taxable: [''],
    toReceive: [0, Validators.required],
    toReject: [0, Validators.required],
    transferDate: [''],
    transferStatus: [''],
    unitCost: [0, Validators.required],
    uom: ['']
  });
}

// Método para el botón "Agregar Línea"
agregarLinea() {
  this.detalles.push(this.crearLinea());
}

// Método para eliminar una línea específica
removerLinea(index: number) {
  if (this.detalles.length > 1) {
    this.detalles.removeAt(index);
  }
}

guardarOrden() {
  if (this.ordenForm.valid) {
    const orden: ServiceOrder = {
      ...this.ordenForm.value,
      detalles: this.detalles.value // aquí ya tienes el array de detalles
    };

    console.log('Datos a enviar al API:', orden);

    this.serviceOrderService.createServiceOrder(orden).subscribe({
      next: (resp) => {
        console.log('Respuesta del backend:', resp);
        alert('Orden guardada correctamente');
        this.ordenForm.reset();
        this.detalles.clear(); // limpiar detalles
        this.agregarLinea();   // dejar al menos una línea vacía
      },
      error: (err) => {
        console.error('Error al guardar la orden', err);
        alert('Hubo un error al guardar la orden');
      }
    });

  } else {
    alert('Por favor, llena todos los campos obligatorios');
  }
}



}
